import Text from '../json/Quotes.json'
import '../css/Estilos.css'
import '../css/neon.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTwitterSquare } from '@fortawesome/free-brands-svg-icons';

import { useState } from 'react';

const Quotes=()=>{
    let cantidadQuotes=(Text.quotes).length-1

let Random=(min=0,max=cantidadQuotes)=>{
  return Math.round(Math.random() * (max - min) + min);
}
let colores=["estiloNeonVerde","estiloNeonAzul","estiloNeonAmarillo","estiloNeonRojo","estiloNeonMorado","estiloNeonRosado"]
let cantidadColores=colores.length-1


let Neon=()=>{
    let numeroColor=Random(0,cantidadColores)
    setColor(colores[numeroColor])
}

const [color,setColor]=useState(colores[Random(0,cantidadColores)])
const [quote,setQuote]=useState(Text.quotes[Random()])



let ChangeQuote=()=>{
    setQuote(Text.quotes[Random()])
    Neon()
}


/* const state=useState(random); 
console.log(state);*/
let text=quote;

    return (
        <div className='body containerFilas rellenoDegradado estilosTexto '>
            <div className="containerColumnas">
                <div className={`estiloRedondeado ${color}`}>
                    <p>" {text.quote}"</p>
                    <div className="alineacionDerecha">
                        {text.author}
                    </div>

                    <br />

                    <div className="containerFilas">

                        <button   button onClick={ChangeQuote} className="boton">
                            New Quote
                        </button>

                        <button className="boton">
                            <a href={`https://twitter.com/intent/tweet?text=menssage: "${text.quote}" to author ${text.author} &url=http%3A%2F%2Facademlo.com&hashtags=programación,html`} target="_blank" className="boton">
                            <FontAwesomeIcon icon={faTwitterSquare} />
                            </a>
                        </button>

                    </div>
                </div>
            </div>  
        </div>
        );
}
export default Quotes